import { useCallback, useEffect } from "react";
import { isAccentureBuild } from "../helpers/utils";

const CookieConsentContainer = () => {
	const gtmId = isAccentureBuild ? "GTM-PB4S9Q5" : "GTM-M6QP85T"

	const determineActivityConsent = useCallback(() => {
		if (typeof Cookiebot !== "undefined") {
			var pageScroll = window.scrollY;
			var halfWindowHeight = Math.round(window.innerHeight / 2);

			if (pageScroll >= halfWindowHeight && !Cookiebot.consented) {
				Cookiebot.submitCustomConsent(true, true, true);
				Cookiebot.hide();
				window.removeEventListener("scroll", determineActivityConsent);
			}
		}
	}, []);

	const cookieScriptAccepted = useCallback(() => {
		if (Cookiebot.consent.marketing) {
			window.intercomSettings = {app_id: process.env.GATSBY_INTERCOM_ID};

			(function () {
				var w = window;
				var ic = w.Intercom;
				if (typeof ic === "function") {
					ic("reattach_activator");
					ic("update", intercomSettings);
				} else {
					var d = document;
					var i = function () {
						i.c(arguments);
					};
					i.q = [];
					i.c = function (args) {
						i.q.push(args);
					};
					w.Intercom = i;

					function l() {
						var s = d.createElement("script");
						s.type = "text/javascript";
						s.async = true;
						s.src = `https://widget.intercom.io/widget/${process.env.GATSBY_INTERCOM_ID}`;
						var x = d.getElementsByTagName("script")[0];
						x.parentNode.insertBefore(s, x);
					}

					l();
				}
			})();
		}

		if (Cookiebot.consent.statistics) {
			// Google analytics
			(function (w, d, s, l, i) {
				w[l] = w[l] || [];
				w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"});
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s),
					dl = l !== "dataLayer" ? "&l=" + l : "";
				j.async = true;
				j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
				f.parentNode.insertBefore(j, f);
			})(window, document, "script", "dataLayer", gtmId);

			if (process.env.GATSBY_ENV === "prod") {
				// Hotjar
				(function (h, o, t, j, a, r) {
					h.hj =
						h.hj ||
						function () {
							(h.hj.q = h.hj.q || []).push(arguments);
						};
					h._hjSettings = {hjid: 2550537, hjsv: 6};
					a = o.getElementsByTagName("head")[0];
					r = o.createElement("script");
					r.async = 1;
					r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
					a.appendChild(r);
				})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
			}
		}
	}, []);

	const cookieScriptLoaded = useCallback(() => {
		window.addEventListener("CookiebotOnDialogDisplay", function (e) {
			var acceptBtn = document.getElementById(
				"CybotCookiebotDialogBodyButtonAccept"
			);
			if (acceptBtn) {
				acceptBtn.classList.add("btn");
				acceptBtn.classList.add("btn-grey");
			}
		});

		window.addEventListener("CookiebotOnAccept", cookieScriptAccepted);
		window.addEventListener("scroll", determineActivityConsent);
	}, [cookieScriptAccepted, determineActivityConsent]);

	useEffect(() => {
		if (typeof document !== "undefined") {
			if (!document.getElementById("cookie-consent-script")) {
				const newScript = document.createElement("script");
				newScript.setAttribute("id", "cookie-consent-script");
				newScript.type = "text/javascript";
				newScript.async = true;
				newScript.src =
					"https://consent.cookiebot.com/uc.js?cbid=103f6cb5-ce66-4e40-871d-7e4ad320c8b3";
				newScript.onload = cookieScriptLoaded;
				document.head.appendChild(newScript);
			}
		}

		return () => {
			if (typeof window !== "undefined") {
				window.removeEventListener("scroll", determineActivityConsent);
			}
		};
	}, [cookieScriptLoaded, determineActivityConsent]);

	return null;
};

export default CookieConsentContainer;
